<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="套餐名称：" name="bundle_name"></c-form-item>
                    <c-form-item type="input" label="套餐描述：" name="bundle_desc"></c-form-item>
                    <c-form-item type="checkbox" label="状态：" name="state" :options="stateOptions"></c-form-item>
                    <c-form-item type="checkbox" label="可售范围：" name="visible_user_level" :options="userLevelOptions"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_bundle_edit" color="sys" @click="navigateTo('/bundle_add')">新建搭配套餐</c-button>
            </m-operate>

            <c-table ref="table">
                <c-table-column label="状态" name="state" width="100">
                    <template v-slot="{data}">
                        <span v-if="data.state === 1" style="color:green">启用</span>
                        <span v-else style="color:red">禁用</span>
                    </template>
                </c-table-column>
                <c-table-column label="套餐名称" name="bundle_name" width="200"></c-table-column>
                <c-table-column
                        label="可售范围"
                        width="90"
                        name="visible_user_level_name"
                >
                    <template #default="{data}">
                        <span v-if="data.visible_user_level_name && data.visible_user_level_name == '全部会员'" style="color:blue">全部会员</span>
                        <span v-else-if="data.visible_user_level_name" v-for="(item, i) in data.visible_user_level_name.split(',')" :key="i" style="color:darkslategrey;display: block;">{{item}}</span>
                        <span v-else></span>
                    </template>
                </c-table-column>
                <c-table-column label="套餐描述" name="bundle_desc" width="300"></c-table-column>
                <c-table-column label="套餐价格" name="bundle_price" width="120">
                    <template v-slot="{data}">￥{{ parseFloat(data.bundle_price).toFixed(2) }}</template>
                </c-table-column>
                <c-table-column label="创建人" name="create_user" width="90"></c-table-column>
                <c-table-column label="创建时间" name="create_date" width="160"></c-table-column>
                <c-table-column label="更新人" name="update_user" width="90"></c-table-column>
                <c-table-column label="更新时间" name="update_date" width="160"></c-table-column>
                <c-table-column type="button" fixed="right" label="操作" width="160">
                    <template v-slot="row">
                        <c-table-button @click="navigateTo(`/bundle_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button power="b_bundle_edit" @click="navigateTo(`/bundle_edit/${row.data.id}`)">编辑</c-table-button>
                        <c-table-button power="b_bundle_state" @click="changeState(row)">{{ row.data.state === 1 ? '禁用' : '启用' }}</c-table-button>
                        <c-table-button power="b_bundle_remove" @click="removeBundle(row)">删除</c-table-button>
                        <c-table-button @click="saleAnalysis(row)">套餐销售情况</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
            <c-dialog ref="saleAnalysisDialog"
                :title="saleBundleDialogTitle"
                width="1000"
                height="auto"
                :button="true"
                :close-button="true"
                >
                <m-search ref="searchSaleAnalysis" @search="searchSaleAnalysisHandle">
                    <c-form>
                        <c-form-item type="datetime" date-type="date" label="统计时间" start-name="start_date" end-name="end_date"></c-form-item>
                    </c-form>
                </m-search>

                <c-table ref="salesAnalysisTable" style="height:600px">
                    <c-table-column label="昵称" name="nick_name" width="100">
                    </c-table-column>
                    <c-table-column label="手机号" name="user_manage_mobilephone" width="100">
                    </c-table-column>
                    <c-table-column label="下单时间" name="create_date" width="120"></c-table-column>
                    <c-table-column label="下单商品数量" name="product_count" width="100"></c-table-column>
                    <c-table-column label="下单商品金额" name="product_money" width="120">
                        <template v-slot="{data}">￥{{ parseFloat(data.product_money).toFixed(2) }}</template>
                    </c-table-column>
                    <c-table-column label="订单号" name="order_number" width="120">
                        <template v-slot="{data}">
                            <p>{{data.order_number}}</p>
                            <p style="margin-top: 2px;" ><a @click="navigateTo(`/order_detail/${data.order_number}`)" power="b_order_detail" style="color: blue">订单详情</a></p>
                        </template>
                    </c-table-column>
                </c-table>
            </c-dialog>

        </module>
    </page>
</template>

<script>
export default {
    name: 'm_bundle',

    data() {
        return {
            stateOptions: [
                { name: '启用', value: 1 },
                { name: '禁用', value: 2 }
            ],
            selectId:0,
            saleBundleDialogTitle:'',
            userLevelOptions: []
        };
    },

    mounted() {
        this.initUserLevelOptions();
        this.$refs.search.search();
        this.$bus.$on('m_bundle.update', () => {
            this.$refs.search.search();
        });
    },

    beforeDestroy() {
        // 组件销毁前移除事件监听器
        this.$bus.$off('m_bundle.update');
    },

    methods: {
        //加载会员等级列表
        initUserLevelOptions(){
            this.request({
                url: '/user_level/options',
                data: {},
                success: data => {
                    this.userLevelOptions = Array.from(data, item => {
                        return {
                            name: item.name,
                            value: item.value
                        }
                    });
                }
            });
        },

        searchHandle(data) {
            this.$refs.table.load({
                url: '/bundle/list',
                data
            });
        },

        changeState(row) {
            const newState = row.data.state === 1 ? 0 : 1;
            const action = newState === 1 ? '启用' : '禁用';

            this.$confirm({
                text: `确定要${action}此搭配套餐吗？`,
                resolve: () => {
                    this.request({
                        url: '/bundle/updateState',
                        data: {
                            id: row.data.id,
                            state: newState
                        },
                        loading: true,
                        success: () => {
                            this.$message({ text: `${action}成功` });
                            this.$refs.table.update();
                        }
                    });
                }
            });
        },
        removeBundle(row) {
            this.$confirm({
                text: '确定要删除此搭配套餐吗？',
                resolve: () => {
                    this.request({
                        url: '/bundle/remove',
                        data: {
                            id: row.data.id
                        },
                        loading: true,
                        success: () => {
                            this.$message({ text: '删除成功' });
                            this.$refs.table.update();
                        }
                    });
                }
            })
        },
        saleAnalysis(row) {
            this.selectId = row.data.id;
            this.saleBundleDialogTitle = '套餐【'+row.data.bundle_name+'】销售情况';
            this.$refs.searchSaleAnalysis.search();
            this.$refs.saleAnalysisDialog.open();
        },
        searchSaleAnalysisHandle(data){
            this.$refs.salesAnalysisTable.load({
                url: '/statistic/activity/orderSaleAnalysis',
                data: {
                    activity_id: this.selectId,
                    activity_type:7,
                    ...data
                }
            });
        }

    }
};
</script>
